import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { initAppUpdateCheck } from './lib/appUpdate';
import './styles/global.css';

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('Root-Element #root nicht gefunden.');

createRoot(rootEl).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

// Neue Deploys beim Zurueckkehren aus dem Hintergrund automatisch laden (PWA).
initAppUpdateCheck();
